import {
  cover24Hours,
  type IHour,
  parseTimeOnly,
  prettyTimeOnly
} from "@gettactic/api";
import type React from "react";
import { getDateWindowMessage } from "@/features/reserve/utils/hourWindowMessages";

export interface OpenRuleMessageProps {
  rule: IHour;
}

/**
 * One line for an "open" holiday or custom-hours rule, in the same shape as
 * the closed-rule message in RestrictionAlert: date first, underlined name.
 */
export const OpenRuleMessage: React.FC<OpenRuleMessageProps> = ({ rule }) => {
  const isAllDay = cover24Hours(
    parseTimeOnly(rule.start_time),
    parseTimeOnly(rule.end_time)
  );
  const hours = isAllDay
    ? "all day"
    : `between ${prettyTimeOnly(rule.start_time)} and ${prettyTimeOnly(rule.end_time)}`;
  const subject = rule.resource_id ? "this resource" : "the office";
  const window = getDateWindowMessage(rule.since, rule.until);
  return (
    <p>
      {window} {subject} is open:{" "}
      <span className="underline">{rule.name ?? "a holiday"}</span>, {hours}
    </p>
  );
};
